import Vue from 'vue'
import VueRouter from 'vue-router'
import { DEFAULT_SEO, buildCanonical, updateSeo } from '@/utils/seo'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { seo: DEFAULT_SEO }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/Products.vue'),
    meta: {
      seo: {
        title: '雪茄商城 | 古巴雪茄、行貨雪茄選購 - CigarEra 香港雪茄時代',
        description: '在香港雪茄時代 CigarEra 選購歐洲官方授權古巴行貨雪茄，涵蓋熱門品牌、不同品型、規格與會員優惠。'
      }
    }
  },
  {
    path: '/products/:id',
    name: 'ProductDetail',
    component: () => import('@/views/ProductDetail.vue'),
    meta: {
      seo: {
        title: '雪茄商品詳情 - CigarEra 香港雪茄時代',
        description: '查看 CigarEra 香港雪茄時代雪茄商品詳情、規格、價格與庫存，選購歐洲官方授權行貨雪茄。'
      }
    }
  },
  {
    path: '/brands',
    name: 'Brands',
    component: () => import('@/views/Brands.vue'),
    meta: {
      seo: {
        title: '雪茄品牌 | CigarEra 香港雪茄時代',
        description: '瀏覽 CigarEra 香港雪茄時代精選雪茄品牌，了解古巴及各產區雪茄品牌特色與推薦產品。'
      }
    }
  },
  {
    path: '/promotions',
    name: 'Promotions',
    component: () => import('@/views/Promotions.vue'),
    meta: {
      seo: {
        title: '優惠活動 | CigarEra 香港雪茄時代',
        description: '查看 CigarEra 香港雪茄時代最新雪茄優惠、會員折扣及限時活動，享受更划算的雪茄選購體驗。'
      }
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: {
      seo: {
        title: '關於我們 | CigarEra 香港雪茄時代',
        description: '了解 CigarEra 香港雪茄時代的品牌理念、雪茄選品標準、歐洲行貨供應與專業服務。'
      }
    }
  },
  {
    path: '/timeclub',
    name: 'TimeClub',
    component: () => import('@/views/TimeClub.vue'),
    meta: {
      seo: {
        title: 'Time Club 會員計劃 | CigarEra 香港雪茄時代',
        description: '加入 CigarEra Time Club 會員計劃，累積消費積分、兌換禮品並享受會員專屬雪茄優惠。'
      }
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue'),
    meta: {
      seo: {
        title: '聯絡我們 | CigarEra 香港雪茄時代',
        description: '聯絡 CigarEra 香港雪茄時代客服團隊，諮詢雪茄選購、訂單、會員服務與售後支援。'
      }
    }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue'),
    meta: {
      seo: {
        title: '雪茄資訊 | CigarEra 香港雪茄時代',
        description: '閱讀 CigarEra 香港雪茄時代雪茄資訊、品牌故事、品鑑知識與選購指南。'
      }
    }
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('@/views/NewsDetail.vue'),
    meta: {
      seo: {
        title: '雪茄資訊詳情 - CigarEra 香港雪茄時代',
        description: '閱讀 CigarEra 香港雪茄時代雪茄資訊詳情，了解雪茄品牌、品鑑、養護與選購知識。'
      }
    }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('@/views/Cart.vue'),
    meta: {
      seo: {
        title: '購物車 | CigarEra 香港雪茄時代',
        description: '查看 CigarEra 香港雪茄時代購物車內容。',
        robots: 'noindex,nofollow'
      }
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

router.afterEach(to => {
  const seo = (to.meta && to.meta.seo) || DEFAULT_SEO
  updateSeo({
    ...seo,
    canonical: buildCanonical(to.path)
  })
})

export default router
